import { gql } from '@apollo/client';

export interface Input {
  title: string;
  content: string;
}

export const MUTATION = gql`
  mutation CreateRegistrationFormWaiver(
    $formId: Int!
    $title: String!
    $content: String!
    $signatureType: String!
    $filename: String
    $originalFileName: String
  ) {
    createRegistrationFormWaiver(
      input: {
        formId: $formId
        title: $title
        content: $content
        signatureType: $signatureType
        filename: $filename
        originalFileName: $originalFileName
      }
    ) {
      formId
      id
      title
      content
      signatureType
      filename
      originalFileName
      externalId
    }
  }
`;
